function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = "../../node_modules/.pnpm/@umu+ukit-lang@2.4.12_@swc+core@1.2.50_@swc+wasm@1.2.50_@types+node@16.18.0_typescript@4.8.4/node_modules/@umu/ukit-lang/lib sync recursive";